export default function AreaSection() {
  const prefectures = [
    {
      name: '愛知県',
      color: 'blue',
      groups: [
        {
          label: '名古屋市',
          areas: [
            '緑区', '南区', '熱田区', '北区', '天白区', '中村区',
            '守山区', '瑞穂区', '昭和区', '港区', '中川区', '西区',
            '千種区', '中区', '東区', '名東区',
          ],
          consultation: false,
        },
        {
          label: '名古屋市以外',
          areas: [
            '碧南市', '東浦町', '知多市', '知立市', '大府市', '清須市',
            '豊田市', '高浜市', '常滑市', '武豊町', '美浜町', '南知多町',
            '半田市', '西尾市', '阿久比町', '安城市', '岡崎市', '瀬戸市',
            '大口町', '大治町', '弥富市', '長久手市', '東海市', '東郷町',
            '日進市', '扶桑町', 'あま市', '豊明市', '愛西市', '津島市',
            '蟹江町', '飛島村', '豊山町', '尾張旭市', '北名古屋市', '刈谷市',
            '小牧市', 'みよし市', '一宮市', '稲沢市', '岩倉市', '犬山市',
            '江南市', '春日井市',
          ],
          consultation: false,
        },
        {
          label: '要相談エリア',
          areas: [
            '幸田町', '豊橋市', '豊川市', '新城市', '田原市',
            '設楽町', '東栄町', '豊根村', '蒲郡市',
          ],
          consultation: true,
        },
      ],
    },
    {
      name: '岐阜県',
      color: 'green',
      groups: [
        {
          label: '対応エリア',
          areas: [
            '富加町', '美濃市', '神戸町', '関ケ原町', '養老町', '御嵩町',
            '川辺町', '坂祝町', '揖斐川町', '関市', '大野町', '海津市',
            '可児市', '土岐市', '輪之内町', '池田町', '垂井町', '大垣市',
            '山県市', '本巣市', '北方町', '美濃加茂市', '各務原市', '羽島市',
            '岐阜市', '岐南町', '安八町', '多治見市', '笠松町', '瑞穂市',
          ],
          consultation: false,
        },
        {
          label: '要相談エリア',
          areas: [
            '白川町', '白川村', '高山市', '中津川市', '東白川村',
            '飛騨市', '七宗町', '瑞浪市', '八百津町', '恵那市', '郡上市', '下呂市',
          ],
          consultation: true,
        },
      ],
    },
    {
      name: '三重県',
      color: 'orange',
      groups: [
        {
          label: '対応エリア',
          areas: [
            '四日市市', '菰野町', '東員町', '川越町', 'いなべ市',
            '朝日町', '木曽岬町', '桑名市',
          ],
          consultation: false,
        },
        {
          label: '要相談エリア',
          areas: [
            '伊勢市', '鳥羽市', '志摩市', '玉城町', '度会町', '南伊勢町',
            '伊賀市', '名張市', '尾鷲市', '紀北町', '熊野市', '御浜町', '大紀町',
            '亀山市', '津市', '松阪市', '多気町', '明和町', '大台町', '鈴鹿市',
          ],
          consultation: true,
        },
      ],
    },
  ];

  const colorMap: Record<string, { header: string; badge: string; consultBadge: string; dot: string }> = {
    blue: {
      header: 'bg-blue-600',
      badge: 'bg-blue-100 text-blue-700',
      consultBadge: 'bg-amber-100 text-amber-700',
      dot: 'bg-blue-400',
    },
    green: {
      header: 'bg-emerald-600',
      badge: 'bg-emerald-100 text-emerald-700',
      consultBadge: 'bg-amber-100 text-amber-700',
      dot: 'bg-emerald-400',
    },
    orange: {
      header: 'bg-orange-500',
      badge: 'bg-orange-100 text-orange-700',
      consultBadge: 'bg-amber-100 text-amber-700',
      dot: 'bg-orange-400',
    },
  };

  return (
    <section id="area" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-pink-100 px-4 py-2 rounded-full mb-4">
            <i className="ri-map-pin-line text-primary"></i>
            <span className="text-primary font-semibold text-sm">対応エリア</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            対応エリア <strong className="text-primary">一覧</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            愛知県・岐阜県・三重県を中心に幅広いエリアに対応しています。<br />
            要相談エリアもお気軽にご連絡ください。
          </p>
        </div>

        {/* Prefecture Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-10">
          {prefectures.map((pref) => {
            const c = colorMap[pref.color];
            return (
              <div key={pref.name} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100">
                {/* Prefecture Header */}
                <div className={`${c.header} px-6 py-4 flex items-center gap-3`}>
                  <i className="ri-map-2-line text-white text-xl"></i>
                  <h3 className="text-xl font-bold text-white">{pref.name}</h3>
                </div>

                <div className="p-6 space-y-6">
                  {pref.groups.map((group) => (
                    <div key={group.label}>
                      <div className="flex items-center gap-2 mb-3">
                        <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${group.consultation ? c.consultBadge : c.badge}`}>
                          {group.consultation && <i className="ri-information-line mr-1"></i>}
                          {group.label}
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2">
                        {group.areas.map((area) => (
                          <span
                            key={area}
                            className={`inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full border ${
                              group.consultation
                                ? 'border-amber-200 bg-amber-50 text-amber-800'
                                : 'border-gray-200 bg-gray-50 text-gray-700'
                            }`}
                          >
                            <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${group.consultation ? 'bg-amber-400' : c.dot}`}></span>
                            {area}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        {/* Note */}
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-5 flex items-start gap-3">
          <i className="ri-information-line text-amber-500 text-xl flex-shrink-0 mt-0.5"></i>
          <p className="text-sm text-amber-800 leading-relaxed">
            <strong>要相談エリア</strong>については、距離・内容によって対応可否や追加交通費が発生する場合がございます。まずはお気軽にお電話またはお問い合わせフォームよりご相談ください。
          </p>
        </div>
      </div>
    </section>
  );
}
